<template>
  <div class="pay-success">
    <div class="suc-top">
        <h2>感谢您购买索尼产品</h2>
        <p>衷心感谢您的惠顾，您的订单已确认提交</p>
        <p>您的订单编号:&nbsp;&nbsp;<span class="order-id">{{orderId}}</span></p>
        <p class="p-t order-id">收到货物15天内，系统将自动将相应成长值发放到您的账户</p>
        <button @click="toAlipay"  v-show="!paysuccess">在线支付（支付宝）</button>
        <p v-show="paysuccess" class="order-suc">
            <span>✔</span>
            支付成功
        </p>
        <p class="p-t1">注:支付状态更新有延迟，如您已完成在线支付，请勿再次点击支付按钮以避免重复支付</p>
    </div>
    <div class="suc-order">
        <div class="order-address">
            <div class="icon-address" >
                <img src="../assets/image/order/address.png">
            </div>
            <div class="adr-content">
                <p class="adr-name">{{dAddressName}}&nbsp;&nbsp;&nbsp;&nbsp;{{dAddressTel}}</p>
                <p class="adr-addr">{{dAddressDesc}}</p>
            </div>
            <img class="adr-bg" src="../assets/image/order/address-bg.png">
        </div>
        <div class="order-product clearfix">
            <div class='ord-pro clearfix'>
                <div v-for="item in mainList">
                    <img :src="BASE_URL+item.imgURL">
                </div>
            </div>
            <ul class='ord-tip'>
                <li>
                    <span>件数</span>
                    <span class="sub-color fr">{{totalQuantity}}</span>
                </li>
                 <li>
                    <span class="sub-color">总商品金额</span>
                    <span class="sub-color fr">RMB {{totalPrice}}</span>
                </li>
                 <!--<li>-->
                    <!--<span>运费</span>-->
                    <!--<span class="fr">RMB {{freight}}</span>-->
                <!--</li>-->
            </ul>
        </div>
        <div class="order-msg">
            <p></p>
            <ul class="ord-pay">
                <li class="f-b">
                    <span>支付方式</span>
                    <span class="fr m-r">在线支付</span>
                </li>
                <li>
                    <span>电子发票抬头</span>
                    <span class="fr m-r">{{invoiceTitle}}</span>
                </li>
            </ul>
        </div>
        <div class="sub-msg">
            <p></p>
            <div class="submsg-tip">
            <a class="sub-color">关于电子发票</a>
            <a class="fr sub-color ">公司发票样票</a>
            <a class="fr sub-color last-msg">个人发票样票</a>
            </div>
        </div>
        <div class="sub-remarks">
            <span>备&nbsp;&nbsp;&nbsp;&nbsp;注</span>
            <span>{{remarks}}</span>
        </div>
        <div class="sub-statement">
            <ul>
                <li>用户须知:</li>
                <li class="fir-state">1.根据您已阅读过的销售条款和条件,如您的订单被接受的情形下，我们将另行通过电子邮件或其他方式向您发出承诺接受的通知</li>
                <li>2.由于页面设置，打印格式等原因，最终寄送给您的订购明细或电子发票上的各种商品信息（包括名称，单价，总价）可能与本页面显示有所差异，但订单的商品合计金额不会发生改变</li>
            </ul>
        </div>
    </div>

  </div>
</template>
<script>
export default {
  data(){
      return{
        api: this.$store.state.api,
        BASE_URL: BASE_URL,
        orderId:'',
        paysuccess: false,
        totalPrice: '',
        dAddressName: '',
        dAddressTel: '',
        dAddressDesc: '',
        finalPrice: '',
        freight: '',
        invoiceTitle: '',
        remarks:'',
        itemList: [],
        mainList: [],
        payForm: ''
      }
    },
    created() {
      this.orderId = this.$route.query.orderId
      this.getOrderInfo();
    },
    computed: {
      totalQuantity() {
        return this.mainList.length;
      }
    },
    methods: {
      toAlipay(){
        let url = this.api.order.alipay(this);
        this.$http.post(url,{
          orderId: this.orderId,
          amountType: 'NORMAL_AMOUNT'
        })
        .then(res=>{
           if(res.data.resultMsg[0].code=='00'&&res.data.resultMsg[0].message=='Success'){
             document.body.innerHTML =res.data.resultData.alipayForm;
             document.forms[0].submit();
           }
        })
      },
      getOrderInfo() {
        let url = this.api.order.getOrder(this);
        this.$http.post(url,JSON.stringify({
          orderId: this.orderId
        })
        ).then(res=>{
          if(res.data.resultMsg[0].code=='00'){
             this.cartId = res.data.resultData.header.cartId;
             this.totalPrice = res.data.resultData.header.totalPrice;
             this.remarks = res.data.resultData.header.remarks;
             this.invoiceTitle = res.data.resultData.header.invoiceTitle;
             this.itemList = res.data.resultData.itemList;
             if(this.itemList) {
              this.resolveList(this.itemList);
             }else {
              this.mainList = [];
             }
             this.getAddress(res.data.resultData.header.dAddress);

          }
        })
        .catch({

        })
      },
      getAddress(_address) {
        let arr = _address.split(',');
        this.dAddressName = arr[0];
        this.dAddressTel = arr[1];
        this.dAddressDesc = arr[3]+arr[4]+arr[5]+arr[6]+arr[7];
      },
      resolveList(data) {
          this.mainList = [];
          var url = this.api.product.findMasterData();
          for(let i=0;i<data.length;i++){
              this.$http.get(url,
                {
                  params: {
                  'eightD': data[i].product8D
                  }
                }
              ).then(res=>{
                if(res.data.result && res.data.code=='00') {
                console.log(data[i].product8D+':'+res.data.returnData.OutMasterData.imagePath)
                  data[i].imgURL = res.data.returnData.OutMasterData.imagePath;
                  this.mainList.push(data[i]);
                }
              })
          }
      },
  }
}
</script>
<style scoped>
    .pay-success{
        width:100%;
    }
    .suc-top{
        width:80%;
        margin:0 auto;
    }
    .suc-top h2{
        padding: 16px 0 14px 0;
        color: #0A83D6;
        font-weight: 500;
        font-size: 18px;
    }
    .suc-top p{
        color:#ADADAD;
        font-size: 10px;
        line-height: 16px;
    }
    .suc-top button{
        width:100%;
        outline: none;
        border:none;
        height:35px;
        background:#0A83D6;
        color:#fff;
        font-size: 16px;
    }
    .suc-top  .order-suc{
        width:100%;
        text-align: center;
        color:#0A83D6;
        font-size:16px;
    }
    .suc-top  .order-suc span{
        display: inline-block;
        width:20px;
        height:20px;
        line-height: 20px;
        border-radius:50%;
        background: #0A83D6;
        color:#fff;
    }
    .suc-top .order-id{
        color:#0A83D6;
        font-size: 11px;
    }
    .p-t {
        padding:20px 0;
    }
    .p-t1{
        padding:25px 0 15px 0;
        font-size: 10px;
    }
    .suc-order{
        width:100%;
        background: #fff;
        border-top:1px solid #E2E2E2;
        padding-top: 15px;
    }
    .icon-address{
        float: left;
        width:10%;
        margin-left: 4%;
    }
    .icon-address img{
        width:20px;
        height:20px;
        margin-top:26px;
    }
    .adr-content{
        width:80%;
        float: left;
    }
    .adr-content .adr-name{
        color:#000;
        font-size: 16px;
        font-weight: 500;
    }
    .adr-content .adr-addr{
        color:#676767;
        font-size: 14px;
        padding-top:12px;
    }
    .suc-order .adr-bg{
        width:100%;
        height:4px;
        margin-bottom:5px;
        margin-top:14px;
    }
    .order-product{
        width:100%;
        padding-top:10px;
        border-top:1px solid #E2E2E2;
    }
    .order-product .ord-pro{
        width: 100%;
        height: 70px;
        overflow: hidden;
        padding: 0 18px 10px 18px;
    }
    .order-product .ord-pro div{
        width:60px;
        height:60px;
        border:1px solid #eee;
        display: inline-block;
        margin-right:10px;
        margin-bottom: 15px;
    }

    .order-product .ord-pro img{
        width:95%;
    }
    .order-product .ord-tip{
        width: 90%;
        margin:0 auto;
        border-top:1px solid #E2E2E2;
        padding:10px 0;
    }
    .order-product .ord-tip li{
        height:24px;
        font-size: 12px;
        line-height: 12px;
    }
    .order-msg{
        width:100%;
    }
    .order-msg p{
        width:100%;
        height:8px;
        background: #F8F8F8;
        border-top:1px solid #E2E2E2;
        border-bottom:1px solid #E2E2E2;
    }
    .order-msg .ord-pay{
        width:95%;
        margin-left:5%;
    }
    .order-msg .ord-pay li{
        width:100%;
        height:50px;
        line-height: 50px;
        font-weight: 500;
        color:#000;
        font-size:16px;
    }
    .f-b{
        border-bottom:1px solid #E2E2E2;
    }
    .m-r{
        margin-right:10%;
    }
    .sub-msg p{
        width:100%;
        height:8px;
        background: #F8F8F8;
    }
    .sub-msg .submsg-tip{
        width:90%;
        margin-left:5%;
        height:50px;
        line-height: 50px;
    }
    .sub-msg .submsg-tip a{
        text-decoration:underline;
        font-size: 12px;
    }
    .sub-msg .submsg-tip a.last-msg{
        margin-right:5%;
    }
    .sub-remarks{
        width:100%;
        border-top:1px solid #E2E2E2;
        height:50px;
        line-height: 50px;
        padding: 0 18px;
    }
    .sub-remarks span{
        font-size: 16px;
    }
    .sub-statement{
        width:100%;
        background: #E1E1E1;
    }
    .sub-statement ul{
        width:90%;
        margin: 0 auto;
        padding:32px 0 38px 0;
    }
    .sub-statement ul li{
        color:#C1C1C1;
        font-size:11px;
    }
    .sub-statement ul li:not(:first-child){
        text-indent:2em;
    }
    .fir-state{
        padding-bottom: 10px;
    }

</style>



// WEBPACK FOOTER //
// src/components/PaySuccess.vue